function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "layer-1",
    viewBox: "0 0 500 372.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-278"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 327.45,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 343.54,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.38,
    y: 343.54,
    width: 70.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.14,
    y: 334.26,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 335.94,
    width: 34.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 335.94,
    width: 62.35,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.33,
    y: 340.16,
    width: 36.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,282.85H43.91a5.71,5.71,0,0,1-5.7-5.71V5.71A5.71,5.71,0,0,1,43.91.05H237a5.71,5.71,0,0,1,5.71,5.71h0V277.14A5.71,5.71,0,0,1,237,282.85ZM43.91.25a5.46,5.46,0,0,0-5.45,5.46V277.14a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V5.71A5.48,5.48,0,0,0,237,.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,282.85H260.21a5.73,5.73,0,0,1-5.71-5.71V5.71A5.72,5.72,0,0,1,260.21.05h193.1A5.71,5.71,0,0,1,459,5.71V277.14A5.7,5.7,0,0,1,453.31,282.85ZM260.21.25a5.48,5.48,0,0,0-5.46,5.46V277.14a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V5.71A5.48,5.48,0,0,0,453.31.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.32,
    y: 19.83,
    width: 259.11,
    height: 156.78,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.28,
    y: 19.83,
    width: 261.4,
    height: 156.78,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.53,
    y: 27.66,
    width: 246.88,
    height: 141.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.88 168.76 241.73 27.67 219.35 27.67 272.5 168.76 294.88 168.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.16 168.76 213 27.67 197.59 27.67 250.75 168.76 266.16 168.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.25 168.76 119.09 27.67 103.68 27.67 156.83 168.76 172.25 168.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.04,
    y: 27.67,
    width: 8.66,
    height: 141.1,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.05,
    y: 27.67,
    width: 8.66,
    height: 141.1,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.19,
    y: 21.84,
    width: 10.94,
    height: 151.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.21,
    y: 21.83,
    width: 10.94,
    height: 151.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.54,
    y: 27.67,
    width: 0.77,
    height: 141.1,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.29,
    y: 9.74,
    width: 275.97,
    height: 2,
    rx: 0.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.43,13.54h0a1.28,1.28,0,0,0,1.26-1.26V9.21a1.27,1.27,0,0,0-1.26-1.27h0a1.25,1.25,0,0,0-1.26,1.26h0v3.07a1.25,1.25,0,0,0,1.26,1.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.34,13.54h0a1.25,1.25,0,0,0,1.26-1.26h0V9.21a1.25,1.25,0,0,0-1.25-1.27h0a1.27,1.27,0,0,0-1.26,1.27v3.07A1.28,1.28,0,0,0,71.34,13.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 10.74,
    width: 261.27,
    height: 111.87,
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.93,
    y: 51.86,
    width: 66.14,
    height: 67.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.94,
    y: 51.86,
    width: 68.39,
    height: 67.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.66,
    y: 59.53,
    width: 56.93,
    height: 52.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.16,
    y: 205.71,
    width: 18.51,
    height: 116.12,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.2,
    y: 321.83,
    width: 203.91,
    height: 5.61,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 205.72,
    width: 192.5,
    height: 116.12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.16,
    y: 200.82,
    width: 18.51,
    height: 4.9,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 200.82,
    width: 192.5,
    height: 4.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.51,246.3H230.31V216.05h179.2Zm-178-1.25H408.26V217.24H231.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.51,311.55H230.31V253.73h179.2Zm-178-1.24H408.26V255H231.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.45,
    y: 216.63,
    width: 130.91,
    height: 3.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.45,
    y: 254.35,
    width: 130.91,
    height: 3.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.07,
    y: 198.7,
    width: 71.14,
    height: 2.12,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.21 198.7 294.07 198.7 300.91 157.97 372.05 157.97 365.21 198.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.89 198.7 292.75 198.7 299.59 157.97 370.73 157.97 363.89 198.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,195.5l5.82-34.63a.9.9,0,0,1,.9-.76h65a.89.89,0,0,1,.91.89.5.5,0,0,1,0,.17l-5.82,34.63a.9.9,0,0,1-.9.76h-65a.89.89,0,0,1-.91-.89A.5.5,0,0,1,295.45,195.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.97,
    y: 198.7,
    width: 71.14,
    height: 2.12,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.07,187.93H131c-8.58,0-16.32,7.43-18.34,17.61l-6.37,32-13.07,0h0c-6.23,0-11.59,5.33-12.76,12.71l-1.74,11c-2.63.45-4.89,2.87-5.53,6.08h78.6c8.57,0,16.3-7.42,18.32-17.59l9.14-46C180.86,195.46,176,187.93,169.07,187.93ZM91.82,261.05H82.15L83.77,251c.87-5.43,4.83-9.38,9.42-9.38h12.27L104,249.43C102.61,256.16,97.49,261.05,91.82,261.05Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.14 267.24 152.9 267.24 158.13 327.45 155.37 327.45 150.14 267.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.78 267.24 142.54 267.24 147.77 327.45 145.01 327.45 139.78 267.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.17 267.24 82.41 267.24 77.18 327.45 79.94 327.45 85.17 267.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.53 267.24 92.77 267.24 87.54 327.45 90.3 327.45 95.53 267.24",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-278"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-278",
    cx: 250,
    cy: 361.29,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--progress-indicator--inject-278"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 23.55,
    width: 266,
    height: 118.44,
    rx: 13.49,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 23.55,
    width: 266,
    height: 118.44,
    rx: 13.49,
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 26.55,
    width: 260,
    height: 112.44,
    rx: 10.49,
    style: {
      fill: "#fff",
      opacity: 0.8999999761581421,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,74.05V66.89H229a5.71,5.71,0,0,1,1.09.07,2.35,2.35,0,0,1,.88.33,1.74,1.74,0,0,1,.57.69,2.15,2.15,0,0,1,.22,1,2.22,2.22,0,0,1-.58,1.55,2.81,2.81,0,0,1-2.1.63h-1.84v2.89Zm.94-3.76H229a2,2,0,0,0,1.31-.34,1.25,1.25,0,0,0,.38-1,1.33,1.33,0,0,0-.22-.77,1.07,1.07,0,0,0-.6-.42,3.78,3.78,0,0,0-.89-.07h-1.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.79,74.05V68.86h.8v.79a2.2,2.2,0,0,1,.55-.73,1.06,1.06,0,0,1,.57-.17,1.7,1.7,0,0,1,.9.28l-.3.81a1.36,1.36,0,0,0-.65-.19.78.78,0,0,0-.51.18.89.89,0,0,0-.33.48,3.37,3.37,0,0,0-.15,1v2.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.81,71.47a2.64,2.64,0,0,1,.8-2.14,2.42,2.42,0,0,1,1.63-.57,2.34,2.34,0,0,1,1.75.7,2.68,2.68,0,0,1,.68,1.93,3.59,3.59,0,0,1-.3,1.58,2.28,2.28,0,0,1-.88.89,2.58,2.58,0,0,1-1.25.32,2.36,2.36,0,0,1-1.76-.7A2.79,2.79,0,0,1,235.81,71.47Zm.9,0a2.22,2.22,0,0,0,.43,1.49,1.42,1.42,0,0,0,1.1.49,1.36,1.36,0,0,0,1.09-.5,2.25,2.25,0,0,0,.43-1.51,2.13,2.13,0,0,0-.44-1.46,1.37,1.37,0,0,0-1.08-.5,1.44,1.44,0,0,0-1.1.5,2.16,2.16,0,0,0-.43,1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.53,74.49l.86.12a.78.78,0,0,0,.3.58,1.4,1.4,0,0,0,.89.25,1.57,1.57,0,0,0,.94-.25,1.26,1.26,0,0,0,.45-.68,5.32,5.32,0,0,0,.07-1.13,1.86,1.86,0,0,1-1.44.68,2,2,0,0,1-1.66-.77,3,3,0,0,1-.58-1.85,3.38,3.38,0,0,1,.27-1.37,2.19,2.19,0,0,1,.78-1,2.09,2.09,0,0,1,1.19-.34,1.85,1.85,0,0,1,1.52.74v-.63h.81v4.49a4.16,4.16,0,0,1-.25,1.71,1.83,1.83,0,0,1-.78.8,2.59,2.59,0,0,1-1.31.29,2.56,2.56,0,0,1-1.5-.41A1.43,1.43,0,0,1,241.53,74.49Zm.73-3.12a2.26,2.26,0,0,0,.41,1.49,1.29,1.29,0,0,0,1,.47,1.28,1.28,0,0,0,1-.47,2.17,2.17,0,0,0,.41-1.46,2.1,2.1,0,0,0-.42-1.43,1.27,1.27,0,0,0-2,0A2.1,2.1,0,0,0,242.26,71.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,74.05V68.86H248v.79a2.1,2.1,0,0,1,.56-.73,1,1,0,0,1,.56-.17,1.62,1.62,0,0,1,.9.28l-.3.81a1.29,1.29,0,0,0-.64-.19.82.82,0,0,0-.52.18,1,1,0,0,0-.33.48,3.77,3.77,0,0,0-.14,1v2.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,72.39l.91.11a2.24,2.24,0,0,1-.8,1.24,2.68,2.68,0,0,1-3.29-.27,2.75,2.75,0,0,1-.67-2,2.87,2.87,0,0,1,.68-2,2.3,2.3,0,0,1,1.75-.72,2.23,2.23,0,0,1,1.7.7,2.91,2.91,0,0,1,.65,2v.23H251.2a2,2,0,0,0,.49,1.31,1.42,1.42,0,0,0,1.08.45,1.36,1.36,0,0,0,.83-.25A1.76,1.76,0,0,0,254.14,72.39ZM251.25,71h2.9a1.65,1.65,0,0,0-.34-1,1.34,1.34,0,0,0-1.08-.51,1.4,1.4,0,0,0-1,.4A1.59,1.59,0,0,0,251.25,71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,72.51l.87-.14a1.23,1.23,0,0,0,.4.8,1.74,1.74,0,0,0,1.84,0,.76.76,0,0,0,.29-.58.56.56,0,0,0-.26-.47,3.66,3.66,0,0,0-.9-.3,7.72,7.72,0,0,1-1.34-.42,1.21,1.21,0,0,1-.56-.49,1.32,1.32,0,0,1-.2-.7,1.39,1.39,0,0,1,.59-1.13,1.91,1.91,0,0,1,.56-.26,2.78,2.78,0,0,1,.76-.1,3.05,3.05,0,0,1,1.08.17,1.49,1.49,0,0,1,.68.48,1.9,1.9,0,0,1,.3.8l-.86.12a1,1,0,0,0-.34-.63,1.23,1.23,0,0,0-.79-.22,1.55,1.55,0,0,0-.87.2.6.6,0,0,0-.26.47.46.46,0,0,0,.11.3.69.69,0,0,0,.34.24c.09,0,.34.11.77.22a12.4,12.4,0,0,1,1.31.41,1.36,1.36,0,0,1,.57.46,1.31,1.31,0,0,1,.21.75,1.53,1.53,0,0,1-.25.83,1.61,1.61,0,0,1-.74.6,2.77,2.77,0,0,1-1.1.22,2.4,2.4,0,0,1-1.54-.42A2,2,0,0,1,255.8,72.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8,72.51l.87-.14a1.23,1.23,0,0,0,.4.8,1.74,1.74,0,0,0,1.84,0,.76.76,0,0,0,.29-.58.56.56,0,0,0-.26-.47,3.66,3.66,0,0,0-.9-.3,7.72,7.72,0,0,1-1.34-.42,1.21,1.21,0,0,1-.56-.49,1.32,1.32,0,0,1-.2-.7,1.39,1.39,0,0,1,.59-1.13,1.91,1.91,0,0,1,.56-.26,2.78,2.78,0,0,1,.76-.1,3.05,3.05,0,0,1,1.08.17,1.49,1.49,0,0,1,.68.48,1.9,1.9,0,0,1,.3.8l-.86.12a1,1,0,0,0-.34-.63,1.23,1.23,0,0,0-.79-.22,1.55,1.55,0,0,0-.87.2.6.6,0,0,0-.26.47.46.46,0,0,0,.11.3.69.69,0,0,0,.34.24c.09,0,.34.11.77.22a12.4,12.4,0,0,1,1.31.41,1.36,1.36,0,0,1,.57.46,1.31,1.31,0,0,1,.21.75,1.53,1.53,0,0,1-.25.83,1.61,1.61,0,0,1-.74.6,2.77,2.77,0,0,1-1.1.22,2.4,2.4,0,0,1-1.54-.42A2,2,0,0,1,260.8,72.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4,74.05v-1h1v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,74.05v-1h1v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,74.05v-1h1v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.51,26.55h-239A10.51,10.51,0,0,0,120,37.05V48.29H380V37.05A10.52,10.52,0,0,0,369.51,26.55Z",
    style: {
      fill: "#2F8DE4",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,37.42a3.8,3.8,0,1,0-3.8,3.8A3.8,3.8,0,0,0,140.83,37.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,37.42a3.8,3.8,0,1,0-3.8,3.8A3.8,3.8,0,0,0,155.83,37.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.83,37.42a3.8,3.8,0,1,0-3.8,3.8A3.8,3.8,0,0,0,170.83,37.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,97.39H137.66a3.33,3.33,0,0,1-3.33-3.32h0a3.34,3.34,0,0,1,3.33-3.33H362.34a3.34,3.34,0,0,1,3.33,3.33h0A3.33,3.33,0,0,1,362.34,97.39Z",
    style: {
      fill: "#2F8DE4",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,97.39H137.66a3.33,3.33,0,0,1-3.33-3.32h0a3.34,3.34,0,0,1,3.33-3.33H304.51a3.33,3.33,0,0,1,3.32,3.33h0a3.32,3.32,0,0,1-3.32,3.32Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,112.28h-8.52l-4.62-4.63-4.62,4.63H294.7a3.67,3.67,0,0,0-3.65,3.65v10.58a3.67,3.67,0,0,0,3.65,3.65H321a3.67,3.67,0,0,0,3.65-3.65V115.93A3.67,3.67,0,0,0,321,112.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.73,118.21h4.72v1.09a6.38,6.38,0,0,0-1,1.2,7.64,7.64,0,0,0-.79,1.75,8.87,8.87,0,0,0-.31,1.77h-1.61a9.67,9.67,0,0,1,.6-2.38,9.44,9.44,0,0,1,1.29-2.07h-2.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,118.21h3.83v1.29H306l-.14.87a3.13,3.13,0,0,1,.54-.19,2.24,2.24,0,0,1,.52-.06,1.9,1.9,0,0,1,1.41.53,1.77,1.77,0,0,1,.55,1.32,2.33,2.33,0,0,1-.28,1.09,1.88,1.88,0,0,1-.79.79,2.84,2.84,0,0,1-1.32.27,3.74,3.74,0,0,1-1-.11,2,2,0,0,1-.7-.32,2.19,2.19,0,0,1-.47-.49,2.76,2.76,0,0,1-.3-.68l1.64-.18a1,1,0,0,0,.28.6.77.77,0,0,0,.52.2.69.69,0,0,0,.55-.26,1.15,1.15,0,0,0,.22-.76,1.05,1.05,0,0,0-.22-.76.77.77,0,0,0-.59-.24,1,1,0,0,0-.45.11,1.31,1.31,0,0,0-.36.3l-1.37-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.6,119.64a1.84,1.84,0,0,1,.17-.77,1.33,1.33,0,0,1,.54-.56,1.84,1.84,0,0,1,.86-.2,1.58,1.58,0,0,1,1.15.42,1.68,1.68,0,0,1,0,2.22,1.58,1.58,0,0,1-1.15.42,1.84,1.84,0,0,1-.86-.2,1.33,1.33,0,0,1-.54-.56A1.84,1.84,0,0,1,309.6,119.64Zm1.11,0a1.24,1.24,0,0,0,.16.71.37.37,0,0,0,.53.07.46.46,0,0,0,.07-.07,1.35,1.35,0,0,0,.16-.71,1.29,1.29,0,0,0-.16-.72.38.38,0,0,0-.55,0s0,0-.05,0a1.25,1.25,0,0,0-.16.73Zm3.82-1.54h.84L312,124.32h-.83Zm-.74,4.67a1.82,1.82,0,0,1,.21-.72,1.33,1.33,0,0,1,.54-.56,1.73,1.73,0,0,1,.86-.2,1.58,1.58,0,0,1,1.15.42,1.68,1.68,0,0,1,0,2.22,1.58,1.58,0,0,1-1.15.42,1.7,1.7,0,0,1-.86-.2,1.17,1.17,0,0,1-.54-.56,1.91,1.91,0,0,1-.21-.81Zm1.11,0a1.26,1.26,0,0,0,.16.71.37.37,0,0,0,.52.08.3.3,0,0,0,.08-.08,1.17,1.17,0,0,0,.16-.71,1.21,1.21,0,0,0-.16-.72.37.37,0,0,0-.3-.14.33.33,0,0,0-.3.15,1.25,1.25,0,0,0-.16.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.69,133.77l1-4.21a1.26,1.26,0,0,0-.81-1.59,1.09,1.09,0,0,0-.44-.06H234.23c-2.49-13.68-11.34-23.73-8.79-40.35,5-7.86-13-37.07-26.07-19.51-16.93,1.11-1.27,32.87-33.48,41-23.69,6-36.68,19.72-41.91,31.26a13.36,13.36,0,0,0,6.51,1.69h.6a44.8,44.8,0,0,1,8.23-12.35A108.17,108.17,0,0,0,134.75,142H251.16l.29-6.52a1.57,1.57,0,0,0-1.43-1.71A1.82,1.82,0,0,0,249.69,133.77Z",
    style: {
      fill: "#2F8DE4",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,139.68c-2,15.2-4.26,45.18-45.87,48.15-27.48,1.95-39.53-24.17-56.83-32.69,1.53-12.48,7.26-25,7.46-25.5a48.59,48.59,0,0,0-11.94,23.55,39.71,39.71,0,0,0-6.16-1.75c0-11.76,12.45-34.28,44.67-42.4s16.55-39.88,33.48-41c13.09-17.56,31.07,11.65,26.07,19.51C202.22,108.56,217.21,119.05,214.56,139.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27,140.26a3,3,0,0,0-4.94-1.82l-5,4.24a3,3,0,0,0-.48,2.68l.89,2.91a16.91,16.91,0,0,0,6.9-1,4.49,4.49,0,0,0,3-5Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,122.77c.2,1.1.47,2.45.73,3.7s.55,2.53.85,3.79c.6,2.53,1.29,5,2,7.5s1.61,4.84,2.53,7.18a58.52,58.52,0,0,0,3.23,6.55l-2.58-2.05a2.53,2.53,0,0,0,1.8.36,9.48,9.48,0,0,0,3.31-1.16,26.16,26.16,0,0,0,3.73-2.42c1.23-.92,2.5-2,3.62-3l.24-.2a3,3,0,0,1,4.67,3.55,29.84,29.84,0,0,1-3,5,28,28,0,0,1-4,4.43,17.82,17.82,0,0,1-5.87,3.51,13,13,0,0,1-4,.75,12.92,12.92,0,0,1-4.36-.64,4.69,4.69,0,0,1-2.36-1.75l-.22-.3a57.25,57.25,0,0,1-4.66-7.88,80,80,0,0,1-3.39-8.18,86.6,86.6,0,0,1-2.48-8.35c-.34-1.4-.67-2.81-1-4.23s-.52-2.8-.74-4.4a6,6,0,0,1,11.84-1.9Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,332.39c-1.55-7-1.16-8.65-2.42-12.5a25.64,25.64,0,0,0-2.82-6.19c-1.1-2,1-3.67,3.08-3.94,1.63-.2,3.35-.27,5.35-.59l4.32,8.06c-2.28,2.89-4.1,10-3.29,15.38C137.1,336.49,132.94,335.2,132.32,332.39Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,165.62s1.14,59.27,2.35,92.11c3.18,19.43-63.64,59.89-63.64,59.89-1.43.68-5.22-6.73-5.16-8.45,0,0,28.74-42.33,45.86-52.55-19-52.45-13.8-91-13.8-91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,165.62h21.69s-4.34,57.94-9.17,87.36C162.66,202.4,167.57,165.62,167.57,165.62Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,284.05c8.23-10.27,17.75-21,25.4-26.24-1.09,10.16-2.21,22.42-3.07,35-7.19,5.69-14.65,11-20.89,15.21A173.12,173.12,0,0,1,154.16,284.05Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,316.16c-.87.62-2.42,1.75-3.54,2.62a.84.84,0,0,1-1.19-.14,59.43,59.43,0,0,1-5.59-9.4.85.85,0,0,1,.17-1l2.8-2.78a.87.87,0,0,1,1.22,0l.09.11,6.25,9.38A.86.86,0,0,1,144.86,316.16Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,316.16c-.87.62-2.42,1.75-3.54,2.62a.84.84,0,0,1-1.19-.14,59.43,59.43,0,0,1-5.59-9.4.85.85,0,0,1,.17-1l2.8-2.78a.87.87,0,0,1,1.22,0l.09.11,6.25,9.38A.86.86,0,0,1,144.86,316.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,366.29c-7.3,0-6.79-.11-10.91-.25-3.52-.13-4.33.31-7.16.25-2.36-.05-2.48-2.31-2-4.91.25-1.31.67-2.9,1-5h11.1a12.44,12.44,0,0,0,9.13,5.59C182.2,362.48,180,366.29,177.07,366.29Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,165.62s-11.48,63.2-15.69,91.85c-4.41,30.08-9.86,78.91-6.86,98.9-1.62,1-7.64,1.05-11.1,0,0,0-17.55-68.61-2.89-97.57-8.34-70.41,4-74.07,7.4-93.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.55,352.2a28.59,28.59,0,0,0,.76,4.11.77.77,0,0,1-.52,1,.35.35,0,0,1-.11,0c-4,.65-10-.29-11.87-.63a1,1,0,0,1-.75-.7l-.95-3.85a.77.77,0,0,1,.5-1,1.24,1.24,0,0,1,.27,0l11.76.22A1,1,0,0,1,169.55,352.2Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.55,352.2a28.59,28.59,0,0,0,.76,4.11.77.77,0,0,1-.52,1,.35.35,0,0,1-.11,0c-4,.65-10-.29-11.87-.63a1,1,0,0,1-.75-.7l-.95-3.85a.77.77,0,0,1,.5-1,1.24,1.24,0,0,1,.27,0l11.76.22A1,1,0,0,1,169.55,352.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.65,110.26c7.28,1.37,8.82,4.35,14.18,15.4-1.62,7.28-10.32,13.67-10.32,13.67S180.64,119.66,192.65,110.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5,165.62c-6.83,9.32-14.27,24.21-14.33,56.21,35.5,16,52.39,16,60.83,12-6.09-24.68-7-68.21-7-68.21C196.33,159.38,162.5,165.62,162.5,165.62Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.44,193.72c-3.11,11.5.08,23,2.82,25.55C187.38,212.63,186.44,193.72,186.44,193.72Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.19,124.05c.12,3.88-.26,8.57-1.13,17.81-.59,7.82,1.36,22.69-1.1,23.78-6.22,1.74-22.55.94-39.46,0-.79-11.2-.5-18.92-7.58-43.92a9.19,9.19,0,0,1,5.88-11.59,9.06,9.06,0,0,1,2-.41c1.57-.16,3.23-.3,4.93-.38a124.49,124.49,0,0,1,17.91,0c1.95.18,4,.42,5.9.69A14.85,14.85,0,0,1,204.19,124.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,92c1,5.89-1.63,13.53-5.38,17.37,0,0,5.46-.82,17.05,6.35,3.36-4.81.87-6.35.87-6.35-3.11-.6-3.11-2.87-1.89-7.25Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,114.27c-3.82.54-5,6.31-5,6.31s-9.17-6.49-12.07-11.06a37.87,37.87,0,0,0,3.35-2.13S181.08,112.05,183.31,114.27Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.94,113.65s3,.66,4.55,4.88c.87-8.41-3.11-9.18-3.11-9.18a4.43,4.43,0,0,0-3.5-.72C187.91,110.23,186.94,113.65,186.94,113.65Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,102.11l-6.25-5.94c.11,1,.28,2.25.51,3.46a13.12,13.12,0,0,0,5.1,7.69C183.78,106.12,184.08,104.41,184.72,102.11Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.49,78.48c-2.45,9.15-3.68,13-.82,19.28,4.3,9.51,15.74,11,20.78,2.95,4.55-7.29,7.79-21,.47-27.94a12.13,12.13,0,0,0-20.43,5.71Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,69.57C181.6,80.51,196,74.13,204.75,86.8,203.92,76,193.32,60.67,180.18,69.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.08,69.16c12.3,8.22-1.16,14.88-10.25,14.39C167.83,74.47,181.08,69.16,181.08,69.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,85.36a4.75,4.75,0,0,0-3.16-1.81A9.67,9.67,0,0,0,187.29,85.36Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.81,86.05a3.93,3.93,0,0,0-3.18-.87A7.87,7.87,0,0,0,186.81,86.05Z",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.11,86.25c-.24.76-.05,1.53.42,1.71s1.05-.28,1.29-1,.05-1.52-.42-1.71S189.35,85.5,189.11,86.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.93,89.86c-.24.76-.05,1.52.42,1.71s1-.28,1.28-1,.05-1.53-.42-1.71S198.16,89.1,197.93,89.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,88.78l1.89.15S199.55,90.05,199,88.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,90.14a23.28,23.28,0,0,0,1,5.85,3.16,3.16,0,0,1-2.73-.5Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,96.67a7.08,7.08,0,0,0,1.17.58.2.2,0,0,0,.27-.1s0,0,0,0a.24.24,0,0,0-.14-.3,6.62,6.62,0,0,1-3.91-4.18.24.24,0,0,0-.27-.18.25.25,0,0,0-.16.29A7,7,0,0,0,188.36,96.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,84.57a6.57,6.57,0,0,0,2,4.86c1.69,1.47,3.63-.35,4.07-2.89.41-2.29,0-5.82-2.13-6.27S172,82.13,172,84.57Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,81.3a.43.43,0,0,0,.35-.06,3.43,3.43,0,0,1,3.21-.34.43.43,0,0,0,.58-.19v0a.51.51,0,0,0-.25-.63,4.26,4.26,0,0,0-4.06.39.48.48,0,0,0-.11.65A.47.47,0,0,0,188.84,81.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.16,86.76a.38.38,0,0,0,.33,0,.46.46,0,0,0,.23-.61h0a4.88,4.88,0,0,0-3.16-2.93.42.42,0,0,0-.5.32.06.06,0,0,0,0,0,.5.5,0,0,0,.37.56,3.94,3.94,0,0,1,2.48,2.35A.49.49,0,0,0,202.16,86.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,85.17l1.9.16S190.73,86.4,190.17,85.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.81,124.68l-3,6.2c-1,2.09-2,4.19-2.91,6.28s-1.81,4.2-2.58,6.27a50.25,50.25,0,0,0-1.88,6l-.19-2.47a3,3,0,0,0,.52,1.18A11.8,11.8,0,0,0,152.2,150a43.54,43.54,0,0,0,4,3.92c1.46,1.3,3,2.57,4.6,3.83s3.24,2.51,4.81,3.73l.1.07a3,3,0,0,1-2.8,5.23,63.28,63.28,0,0,1-6.11-2.45,64.37,64.37,0,0,1-5.87-3.07,42.69,42.69,0,0,1-5.71-4,25,25,0,0,1-2.78-2.76,13.65,13.65,0,0,1-2.52-4.27,4.51,4.51,0,0,1-.24-2.06l0-.42a48.84,48.84,0,0,1,1.72-7.92c.71-2.5,1.56-4.87,2.47-7.22s1.9-4.63,2.93-6.89,2.12-4.44,3.39-6.71a6,6,0,0,1,10.64,5.54Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.42,109.78c-6.5,0-9.35,1.52-16.53,13.45,1.6,5.13,11.9,11.41,11.9,11.41S168.9,120.32,162.42,109.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.27,169.51l-.33-2.92a3.45,3.45,0,0,0-1.75-2.61l-4.53-2.51a6.36,6.36,0,0,0-5.85-.16l-1.16.55c.23,4.89,4.07,10,4.07,10l.94,1.58a2.87,2.87,0,0,0,3.89,1.11h0l3.15-1.81A3.28,3.28,0,0,0,173.27,169.51Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82,151.44H189.54a1.26,1.26,0,0,1-1.31-1.21,1.54,1.54,0,0,1,.06-.43l4.84-20.24a2.24,2.24,0,0,1,2-1.65h34.28a1.26,1.26,0,0,1,1.31,1.21,1.09,1.09,0,0,1-.06.44l-4.85,20.24A2.2,2.2,0,0,1,223.82,151.44Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,149.81h0a.25.25,0,0,1-.19-.3h0L194,130.63a2.46,2.46,0,0,1,2.28-1.84h32.63a.25.25,0,0,1,0,.5H196.23a2,2,0,0,0-1.8,1.45l-4.51,18.88A.26.26,0,0,1,189.67,149.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,133.91l-.45.21a4.32,4.32,0,0,0-2.52,3.52l-.27,4.27a3,3,0,0,0,2.74,3.24h.6a2,2,0,0,0,1.88-1.88l.34-7.81a1.61,1.61,0,0,0-1.46-1.73A1.7,1.7,0,0,0,229.13,133.91Z",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.07,317.69c-3.28-14.66,3.27-49.83,6-57.79s21.68-17.48,33.18-22.63,32.56,8.87,32.56,8.87-21.86-2.29-28.14.84-19.67,12.72-24,20.94S334.77,300.49,334.07,317.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.14,261.16c15.05,1.58,27.39,11.87,31.31,15s5.48,15.72,6.06,23.23S320,316,320,316s5.7-11.84,5.2-16-3.21-13.62-7-17.75S306.2,267.27,294.14,261.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9,308.18c1.41-20.54-8.41-34.07-7-50.33s19.73-52.54,21.32-62.8c3,9.08-10.21,52.75-9.63,64.59S341.4,295.37,329.9,308.18Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9,308.18c1.41-20.54-8.41-34.07-7-50.33s19.73-52.54,21.32-62.8c3,9.08-10.21,52.75-9.63,64.59S341.4,295.37,329.9,308.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9,228.54a13.3,13.3,0,0,1,10.58,9.32,14.19,14.19,0,0,1-13.59,4.84c-6.68-1.24-9-5-8.19-8.87S308.22,227.3,314.9,228.54Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.75,238.74a8.84,8.84,0,0,1-7.88,5,9.45,9.45,0,0,1-.61-9.55c2-4,4.82-4.85,7.16-3.61S337.76,234.7,335.75,238.74Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.23,273.43a8.83,8.83,0,0,1,2.27,9.08,9.44,9.44,0,0,1-9.25-2.49c-3.18-3.19-3.06-6.11-1.13-7.93S328.05,270.23,331.23,273.43Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.26,292.19a5.47,5.47,0,0,1-5.74.73,5.82,5.82,0,0,1,2.2-5.49c2.19-1.72,4-1.44,4.95-.12S341.45,290.47,339.26,292.19Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,263.67a12.33,12.33,0,0,1-12.5,3.91,13.16,13.16,0,0,1,2.69-13.09c4.18-4.69,8.26-4.76,11-2.23S349.68,259,345.5,263.67Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.75,308.86h-.1a.5.5,0,0,1-.4-.58c7.1-37.08.51-69.28-19.59-95.7a.51.51,0,0,1,0-.71.49.49,0,0,1,.7,0l0,.05c20.28,26.66,26.94,59.12,19.79,96.5A.5.5,0,0,1,330.75,308.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,201.05a15.48,15.48,0,0,1,1.87,16.31,16.55,16.55,0,0,1-15.52-6.43c-4.8-6.28-3.91-11.33-.15-14.06S308.18,194.75,313,201.05Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.14,
    y: 316.32,
    width: 15.76,
    height: 1,
    transform: "translate(-28.61 602.97) rotate(-86)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.64,
    y: 333.86,
    width: 6.7,
    height: 1,
    transform: "matrix(0.07, -1, 1, 0.07, -48.12, 617.1)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.34 297.88 312.61 297.88 308.09 361.33 360.87 361.33 356.34 297.88",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,353.77a24.56,24.56,0,1,1,24.56-24.56h0A24.59,24.59,0,0,1,367.28,353.77Zm0-47.12a22.56,22.56,0,1,0,22.56,22.56h0A22.6,22.6,0,0,0,367.28,306.65Z",
    style: {
      fill: "#2F8DE4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportThumbnail);
export default __webpack_public_path__ + "static/media/import-thumbnail.99ec886d4877eb7bf1ab197a344f2abf.svg";
export { ForwardRef as ReactComponent };